export default "__VITE_ASSET__BWR22SzD__"